import phoneFormatter from 'phone-formatter';

export function normalize(formattedPhoneNumber) {
  const truncatedPhoneNumber =
    formattedPhoneNumber.length > 14 ? formattedPhoneNumber.slice(0, 14) : formattedPhoneNumber;
  return phoneFormatter.normalize(truncatedPhoneNumber).replace(/\(|\)|N|\s|-/gi, '');
}

export function format(phoneNumber) {
  return phoneNumber.length > 0
    ? phoneFormatter
        .format(phoneNumber, '(NNN) NNN-NNNN')
        .replace(/N/g, '')
        .replace(/((\)\s-)|-)$/, '')
    : '';
}

export function isMobile() {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}
